const ATTRIBUTION_PARAMS = [
  "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
  "campaign_id", "adset_id", "ad_id", "placement", "site_source_name", "fbclid",
];

const STORAGE_KEY = "granada_attribution_v1";

function randomReference() {
  const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const bytes = new Uint8Array(5);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
  }
  return `GRN-${Array.from(bytes, (value) => alphabet[value % alphabet.length]).join("")}`;
}

export function readAttributionParams(search = "") {
  const query = new URLSearchParams(search);
  return ATTRIBUTION_PARAMS.reduce((result, key) => {
    const value = query.get(key);
    if (value) result[key] = value.slice(0, 500);
    return result;
  }, {});
}

export function captureAttribution(search = window.location.search, storage = window.sessionStorage) {
  const incoming = readAttributionParams(search);
  let existing = {};
  try { existing = JSON.parse(storage.getItem(STORAGE_KEY) || "{}"); } catch {}

  const now = new Date().toISOString();
  const hasIncoming = Object.keys(incoming).length > 0;
  const state = {
    reference: existing.reference || randomReference(),
    firstTouch: existing.firstTouch || (hasIncoming ? { ...incoming, capturedAt: now } : null),
    lastTouch: hasIncoming ? { ...incoming, capturedAt: now } : (existing.lastTouch || null),
  };
  try { storage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch {}
  return state;
}

export function getAttribution(storage = window.sessionStorage) {
  try {
    const saved = JSON.parse(storage.getItem(STORAGE_KEY) || "null");
    if (saved?.reference) return saved;
  } catch {}
  return captureAttribution("", storage);
}

export function getAttributionReference(storage = window.sessionStorage) {
  return getAttribution(storage).reference;
}

export { ATTRIBUTION_PARAMS, STORAGE_KEY };
